export enum SourceType {
  InstagramHashtag = 'InstagramHashtag',
}
